import { hideWaitingPage } from '#src/utils';
import React, { useEffect } from 'react';

import { PageErrorEnum } from './PageError.enum';
import { AlreadyProcessed, Empty, NotFound } from './components';

const DefaultError = () => <div>Error</div>;

export const PageErrorComponent = ({
  pageErrorStatus,
}: {
  pageErrorStatus: PageErrorEnum;
}) => {
  useEffect(() => {
    hideWaitingPage();
  }, []);

  switch (pageErrorStatus) {
    case PageErrorEnum.SHOPPING_BASKET_CLOSED:
      return <AlreadyProcessed />;
    case PageErrorEnum.SHOPPING_BASKET_NOT_FOUND:
      return <NotFound />;
    case PageErrorEnum.SHOPPING_BASKET_EMPTY:
      return <Empty />;
    default:
      return <DefaultError />;
  }
};
